export class StartWithStream<T, A> extends TransformStream<T, A | T> {
  constructor(...values: readonly A[]) {
    super({
      start(controller) {
        for (const next of values) {
          // TODO Prevent enqueue when the stream is closed
          controller.enqueue(next);
        }
      },
    });
  }
}
